import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next'; 
import { useNotification } from '../contexts/NotificationContext'; 

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppData } from "../hooks/useAppData";
import { useUserData } from "../hooks/useUserData";
import { useUserStore } from "../hooks/useUserStore";

import { useAppStore } from "../hooks/useAppStore"; 
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import PasswordStrengthBar from 'react-password-strength-bar';
import '../styles/App.css';
import { 
  ErrorOutline as ErrorOutlineIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  Visibility,
  VisibilityOff, 
} from '@mui/icons-material';

import { 
  Box,
  IconButton, 
  InputAdornment, 
  TextField, 
  Button 
} from '@mui/material';

const Account = ({ onClose, isVisible }) => {
  const { t } = useTranslation(); 
  const { showNotification } = useNotification();
  const queryClient = useQueryClient();

const { 
      baseURL,
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth
  } = useAppStore();

  const { 
      wordList, 
      isWordListPending,
      isWordListError, 
      wordListRefetch,
      updateWordList,
      updateWordListOnReorder,
      addGroup,
      deleteGroup,
      addWordItem,
      deleteWord,
      soundboard,
      shapes,
      isSoundboardPending,
      isSoundboardError, 
      soundboardRefetch,
      addShape,
      updateShape,
      updateButton,
      unassignButton,
      deleteShape,
      handleOptionChange,
      handleAssignedWordTooltipVisibility,
      assignedWordTooltipVisibility
    } = useAppData();


  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [passwordError, setPasswordError] = useState('');

  
  /*const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);*/

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [submitError, setSubmitError] = useState('');
  

  // Fetch user data
  const {
    userQuery: { data: userData, isPending },
    updateAccount,
    updatePassword,
  } = useUserData({
    isVisible,
    onSuccessUIHandlers: {
      onUserFetchSuccess: (data) => {
        setName(data.name);
        setEmail(data.email);
      },
    },
    onErrorUIHandlers: {
      onUserFetchError: () => {
        showNotification({
          notification: t('errors.snackbar.UserDataFetchFailed'),
          type: 'error',
        });
      },
    },
  });

  const isUpdating = updateAccount.isPending;
  const isPasswordUpdating = updatePassword.isPending;
  /*const fetchUserData = async () => {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) throw new Error(t('errors.snackbar.UserTokenNotFound'));
    const response = await axios.get(`${baseURL}/api/users/me`, {
      headers: { Authorization: `Bearer ${userToken}` },
    });
    return response.data;
  };

  const { data: userData, isPending, isError } = useQuery({
    queryKey: ['user'],
    queryFn: fetchUserData,
    enabled: isVisible, // Fetch only when visible
    onSuccess: (data) => {
      setName(data.name);
      setEmail(data.email);
    },
    onError: () => {
      showNotification({
        notification: t('errors.snackbar.UserDataFetchFailed'),
        type: 'error',
      });
    },
  });*/

  /*const updateAccount = async ({ name, email }) => {
    const userToken = localStorage.getItem('userToken');
    return axios.patch(
      `${baseURL}/api/users/user/${userData._id}/updateAccount`,
      { name, email },
      { headers: { Authorization: `Bearer ${userToken}` } }
    );
  };

  const { mutate: updateAccountMutation, isPending: isUpdating } = useMutation({
    mutationFn: updateAccount,
  
    onMutate: async (newData) => {
      await queryClient.cancelQueries(['user']);
      
      const previousUserData = queryClient.getQueryData(['user']);
  
      // Optimistically update UI
      queryClient.setQueryData(['user'], (old) => ({ ...old, ...newData }));
  
      setError(''); // Clear any previous errors
      setSuccess(''); // Reset success message before request
  
      return { previousUserData }; // Return context for rollback
    },
  
    onSuccess: () => {
      setSuccess(t('account.updateSuccessMsg')); 
    },
  
    onError: (_error, _newData, context) => {
      if (context?.previousUserData) {
        queryClient.setQueryData(['user'], context.previousUserData);
      }
      setError(t('account.errors.updateFailed'));
    },
  
    onSettled: () => {
      queryClient.invalidateQueries(['user']); // Ensure data stays fresh
    },
  });

  const updatePassword = async ({ currentPassword, newPassword }) => {
    const userToken = localStorage.getItem('userToken');
    return axios.patch(
      `${baseURL}/api/users/user/${userData._id}/updatePassword`,
      { currentPassword, newPassword },
      { headers: { Authorization: `Bearer ${userToken}` } }
    );
  };

  const { mutate: updatePasswordMutation, isPending: isPasswordUpdating } = useMutation({
    mutationFn: updatePassword,
    onSuccess: () => {
      setPasswordSuccess(t('account.passwordUpdateSucess'));
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    },
    onError: () => {
      setPasswordError(t('account.errors.passwordUpdateFailed'));
    },
  });*/

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePasswordStrength = (password) => {
    return password.length >= 8;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setNameError('');
    setEmailError('');
    setError('');
    setSuccess('');
  
    if (!name.trim()) {
      setNameError(t('errors.nameRequired'));
      return;
    }
    if (!email.trim()) {
      setEmailError(t('errors.emailRequired'));
      return;
    } else if (!validateEmail(email)) {
      setEmailError(t('errors.invalidEmail'));
      return;
    }
  
    updateAccount.mutate(
      { _id: userData._id, name, email },
      {
        onSuccess: () => setSuccess(t('account.updateSuccessMsg')),
        onError: () => setError(t('account.errors.updateFailed')),
      }
    );
  };
  
  const handlePasswordUpdate = (e) => {
    e.preventDefault();
    setPasswordError('');
    setCurrentPasswordError('');
    setNewPasswordError('');
    setConfirmPasswordError('');
  
    if (newPassword !== confirmPassword) {
      setPasswordError(t('account.errors.passwordNotMatched'));
      return;
    }
  
    if (!validatePasswordStrength(newPassword)) {
      setPasswordError(t('errors.passwordTooShort'));
      return;
    }
  
    updatePassword.mutate(
      { _id: userData._id, currentPassword, newPassword },
      {
        onSuccess: () => {
          setPasswordSuccess(t('account.passwordUpdateSucess'));
          setCurrentPassword('');
          setNewPassword('');
          setConfirmPassword('');
        },
        onError: () => {
          setPasswordError(t('account.errors.passwordUpdateFailed'));
        },
      }
    );
  };

  /*const handleSubmit = (e) => {
    e.preventDefault();
    setNameError('');
    setEmailError('');
    setError('');
    setSuccess('');

    if (!name.trim()) {
      setNameError(t('errors.nameRequired'));
      return;
    }
    if (!email.trim()) {
      setEmailError(t('errors.emailRequired'));
      return;
    } else if (!validateEmail(email)) {
      setEmailError(t('errors.invalidEmail'));
      return;
    }

    updateAccountMutation({ name, email });
  };

  const handlePasswordUpdate = (e) => {
    e.preventDefault();

    setPasswordError('');
    setCurrentPasswordError('');
    setNewPasswordError('');
    setConfirmPasswordError('');

    if (newPassword !== confirmPassword) {
      setPasswordError(t('account.errors.passwordNotMatched'));
      return;
    }

    if (!validatePasswordStrength(newPassword)) {
      setPasswordError(t('errors.passwordTooShort'));
      return;
    }
  
    updatePasswordMutation({ currentPassword, newPassword });
  };*/

  /*
  const handleSubmit = async (e) => {
    e.preventDefault();

    setNameError('');
    setEmailError('');
    if (!name.trim()) {
      setNameError(t('errors.nameRequired'));
      return;
    }
    if (!email.trim()) {
      setEmailError(t('errors.emailRequired'));
      return;
    } else if (!validateEmail(email)) {
      setEmailError(t('errors.invalidEmail'));
      return;
    }
    try {
      const userToken = localStorage.getItem('userToken');

      await axios.patch(
        `${baseURL}/api/users/user/${userData._id}/updateAccount`,
        { name, email },
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      setSuccess(t('account.updateSuccessMsg'));
      setError('');
    } catch (error) {
      setError(t('account.errors.updateFailed'));
      setSuccess('');
    }

  };*/

  /* const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setCurrentPasswordError('');
    setNewPasswordError('');
    setConfirmPasswordError('');

    if (newPassword !== confirmPassword) {
      setPasswordError(t('account.errors.passowrdNotMatched'));
      return;
    }
    if (!validatePasswordStrength(newPassword)) {
      setNewPasswordError(t('errors.passwordTooShort'));
      return;
    }
    setLoading(true);
    try {
      const userToken = localStorage.getItem('userToken');
      await axios.patch(
        `${baseURL}/api/users/user/${userData._id}/updatePassword`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      setPasswordSuccess(t('account.passwordUpdateSucess'));
      setPasswordError('');
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setPasswordError(error.response.data.message);
      } else {
        setPasswordError(t('account.errors.passwordUpdateFailed'));
      }
      setPasswordSuccess('');
    } finally {
      setLoading(false);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  };*/

  const clearOverlay = () => {
    setName('');
    setEmail('');

    setPasswordSuccess ('');
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');

    setNameError('');
    setEmailError('');
    setCurrentPasswordError('');
    setNewPasswordError('');
    setNewPasswordError('');
    setSubmitError('');
    setPasswordError('');
    setSuccess('');
    setError('');

  };

  const handleCloseAccountOverlay = () => {
    clearOverlay(); // Clear errors
    onClose(); // Call the passed in close handler to hide the overlay
  };


  /*useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {

          const extra = {  };  
          showNotification({
            notification: t('errors.snackbar.UserTokenNotFound'),
            type: 'error',
            extra, 
            isException: false,
          });

          return;
        }
        const response = await axios.get(`${baseURL}/api/users/me`, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        const data = response.data;
        setUserData(data);
      } catch (error) {

        const extra = { 
          message: 'Failed to fetch user data',
        };

        showNotification({
          notification: t('errors.snackbar.UserDataFetchFailed'),
          type: 'error',
          extra, 
          error,
          isException: false,
        });

      }
    };
  
    if (isVisible) {
      fetchUserData();
    }
  }, [isVisible]);*/

  useEffect(() => {
    if (userData) {
      setName(userData.name || ''); 
      setEmail(userData.email || '');
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <Modal show={isVisible} onHide={handleCloseAccountOverlay} centered className="custom-modal">
      <Modal.Header closeButton className="custom-modal-heading">
        <Modal.Title>{t('account.pageTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          {error && <div className="general-error-message">
              <ErrorOutlineIcon className="feedback-icon" />
              {error}
            </div>}
          {success && <div className="text-success mb-3">
            <CheckCircleOutlineIcon className="feedback-icon" />
            {success}
          </div>}
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label={t('common.nameLabel')}
            name="name"
            autoComplete="name"
            autoFocus
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            error={Boolean(nameError) || Boolean(submitError)}
            helperText={nameError}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label={t('common.emailLabel')}
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            error={Boolean(emailError) || Boolean(submitError)}
            helperText={emailError}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={isUpdating}
          >
            {isUpdating ? t('common.loading') : t('common.submitLabel')}
          </Button>
        </Box>

        <hr />
        <h6>{t('account.passwordTitle')}</h6>
        <Box component="form" onSubmit={handlePasswordUpdate} noValidate sx={{ mt: 1 }}>
          {passwordError && <div className="text-danger mb-3">
            <ErrorOutlineIcon className="feedback-icon" />
            {passwordError}
          </div>}
          {passwordSuccess && <div className="text-success mb-3">
            <CheckCircleOutlineIcon className="feedback-icon" />
            {passwordSuccess}
          </div>}

          <TextField
            type={showCurrentPassword ? 'text' : 'password'}
            margin="normal"
            required
            fullWidth
            id="current-password"
            label={t('account.currentPasswordLabel')}
            name="currentPassword"
            value={currentPassword}
            onChange={(e) => {
              setCurrentPassword(e.target.value);
            }}
            //error={Boolean(currentPasswordError) || Boolean(submitError)}
            //helperText={currentPasswordError}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className="input-adornment">
                  <IconButton
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    edge="end"
                    sx={{
                      borderRadius: '50%', // Make the button circular
                    }}
                  >
                    {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            type={showNewPassword ? 'text' : 'password'}
            margin="normal"
            required
            fullWidth
            id="new-password"
            label={t('account.newPasswordLabel')}
            name="newPassword"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
            }}
            //error={Boolean(newPasswordError) || Boolean(submitError)}
            //helperText={newPasswordError}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className="input-adornment">
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                    sx={{
                      borderRadius: '50%', // Make the button circular
                    }}
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <PasswordStrengthBar password={newPassword} />
          <TextField
            type={showConfirmPassword ? 'text' : 'password'}
            margin="normal"
            required
            fullWidth
            id="confirm-password"
            label={t('account.newPasswordLabel')}
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
            }}
           // error={Boolean(confirmPasswordError) || Boolean(submitError)}
            //helperText={confirmPasswordError}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className="input-adornment">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                    sx={{
                      borderRadius: '50%', // Make the button circular
                    }}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={isPasswordUpdating}
          >
            {isPasswordUpdating ? t('account.updatingLabel') : t('account.updatePasswordLabel')}
            </Button>
        </Box>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default Account;
